// The trend sentence the nightly pipeline writes ("Leaning up — about 3% higher over
// the past 30 days, …") in the reader's language. Those sentences arrive finished, in
// English, from a handful of fixed templates (backend tools/data_preprocessing_functions
// calculate_trend_theilsen_with_explanation). This mirrors the backend's
// applicaite/i18n/fmt.trend_text: the same templates, the same Dutch. Anything that
// matches no template is shown as it came.
import { currentLanguage } from './index.js'

const windowNl = (w) => {
  if (w === 'over the past year') return 'het afgelopen jaar'
  const m = /^over the past (\d+) days$/.exec(w)
  return m ? `de afgelopen ${m[1]} dagen` : w
}
const amount = (a) => a.replace('.', ',')

const WORDS = { rising: 'stijgend', falling: 'dalend', stable: 'stabiel' }
const W = '(over the past (?:year|\\d+ days))'
const RULES = [
  [/^No meaningful trend — daily counts are stable or zero\.$/,
    () => 'Geen duidelijke trend — de dagelijkse aantallen zijn stabiel of nul.'],
  [/^Not enough days yet to read a trend\.$/,
    () => 'Nog te weinig dagen om een trend te lezen.'],
  [new RegExp(`^No clear trend ${W} — visitor numbers are essentially flat\\.$`),
    (m) => `Geen duidelijke trend ${windowNl(m[1])} — de bezoekersaantallen zijn vrijwel gelijk gebleven.`],
  [new RegExp(`^Leaning (up|down) — about ([\\d.]+%) (higher|lower) ${W}, but that is within normal day-to-day variation\\. Not yet a trend\\.$`),
    (m) => `Licht ${m[1] === 'up' ? 'stijgend' : 'dalend'} — ongeveer ${amount(m[2])} ${m[3] === 'higher' ? 'hoger' : 'lager'} `
      + `${windowNl(m[4])}, maar dat valt binnen de normale schommelingen van dag tot dag. Nog geen trend.`],
  [new RegExp(`^Clear (increase|decline) — about ([\\d.]+%) (more|fewer) visitors ${W}\\.$`),
    (m) => `Duidelijke ${m[1] === 'increase' ? 'stijging' : 'daling'} — ongeveer ${amount(m[2])} `
      + `${m[3] === 'more' ? 'meer' : 'minder'} bezoekers ${windowNl(m[4])}.`],
]

export function trendText(text, lang) {
  if ((lang || currentLanguage()) !== 'nl' || typeof text !== 'string') return text
  const s = text.trim()
  if (WORDS[s]) return WORDS[s]
  for (const [rx, say] of RULES) {
    const m = rx.exec(s)
    if (m) return say(m)
  }
  return text
}
